// extracted by mini-css-extract-plugin
export default {"main":"AdminEvent_main__f3Rg-","block":"AdminEvent_block__tqtIb","line":"AdminEvent_line__8ikh9","chart":"AdminEvent_chart__x7H7v"};